<template>
  <div class="page-free-join text-center pt-2 pr-3 pb-3 pl-3">
    <div class="toolbar text-left mb-4">
      <a href="/" class="btn-back" @click.prevent="$router.push({name: 'Main'})">
        <b-icon icon="chevron-left" class="mr-1"/>
        {{ $t("Back") }}</a>
    </div>

    <div class="mb-5 d-block logo">
      <img src="images/full-logo.png" alt="logo" style="max-width: 100%; width: 300px"/>
    </div>

    <ValidationObserver ref="form" tag="form" class="d-block ml-auto mr-auto" style="width: 400px; max-width: 100%"
                        @submit.prevent="enterMeeting()">
      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-input-group class="input-group-trans">
            <b-form-input v-model="formData.transId" :placeholder="$t('Enter a TranS ID')" :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-id.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-input-group class="input-group-trans">
            <b-form-input v-model="formData.displayName" :placeholder="$t('Enter your display name')"
                          :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-user.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group class="mb-1">
        <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">
          {{ $t("Go to Meeting") }}
        </b-button>
      </b-form-group>
    </ValidationObserver>
    <PanelLoading :show="loading" message="Connecting to meeting room..."/>
  </div>
</template>

<script>
import appHelper from "../helpers/app_helper";
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "FreeJoin",
  data: function () {
    return {
      loading: false,
      meetingHistories: [{
        id: "1234",
        Name: "Hung"
      }, {
        id: "1223",
        Name: "Duong"
      }],
      formData: {
        transId: "",
        displayName: ""
      }
    }
  },
  methods: {
    enterMeeting: async function () {
      if ((await this.$refs.form.validate()) != true)
        return;

      if (this.loading == true)
        return;

      this.loading = true;
      const response = await meetingService.freeJoin(this.formData);
      this.loading = false;

      if (!response) return;

      if (response === "REQUIRED_LOGIN") {
        let result = await dialogHelper.confirm("You need to log in before joining the meeting.", "error");
        if (result)
          await this.$router.push({name: 'LogIn', query: {routeName: "FreeJoin"}});

        return;
      }

      if (!response.startsWith("OK|") && !response.startsWith("NOSTART|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      if (response.startsWith("NOSTART|")) {
        let result = await dialogHelper.confirm(response.substr(8));
        if (result) {
          this.enterMeeting();
        }

        return;
      }

      const data = JSON.parse(response.substr(3));
      if (this.meetingHistories.find(x => x.id === this.formData.transId) === null) {
        this.meetingHistories.push({
          id: this.formData.transId,
          Name: data.HostName
        })
      }

      await appHelper.setSetting("displayName", this.formData.displayName);
      let isRunning = await appHelper.isMeetingOpening();
      if (isRunning == null) {
        dialogHelper.alert("Your device is not support virtual meeting.", "warning");
        return;
      }

      if (isRunning) {
        dialogHelper.alert("You are already in another meeting, please leave meeting before enter this meeting.", "warning");
        return;
      }

      const result = await appHelper.openMeeting(data);
      if (result !== 0 && isNaN(result)) {
        dialogHelper.alert(result, "error");
        return;
      }

      await this.$router.push({name: 'Main'});
    }
  },
  async created() {
    this.setTitle("Free Join a Meeting")
    this.formData.displayName = await appHelper.getSetting("displayName") || "";
  }
}
</script>

<style scoped>

</style>